import React from 'react';

const PlaceholderPage = ({ title, children }) => {
  return (
    <div>
      <h2 className="text-2xl font-bold text-black mb-6">{title}</h2>
      <div className="prose max-w-none">
        <p className="text-black mb-6">
          {children || 'This page is under construction. Please check back later for updates.'}
        </p>
      </div>
    </div>
  );
};

export default PlaceholderPage;
